export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || ""

// Track page views
export const pageview = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView")
  }
}

// Track custom events
export const event = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", eventName, parameters)
  }
}

// Track standard events with parameters
export const trackEvent = {
  // Lead generation events
  lead: (parameters?: Record<string, any>) => event("Lead", parameters),
  completeRegistration: (parameters?: Record<string, any>) => event("CompleteRegistration", parameters),

  // Engagement events
  viewContent: (parameters?: Record<string, any>) => event("ViewContent", parameters),
  search: (parameters?: Record<string, any>) => event("Search", parameters),

  // Custom events for your use case
  joinWaitlist: (parameters?: Record<string, any>) => event("JoinWaitlist", parameters),
  demoInteraction: (parameters?: Record<string, any>) => event("DemoInteraction", parameters),
}
